import React from 'react';
import Base from './Base';
import Button from '../Button/Button';
import Spinner, { SpinnerCenterHelper } from '../../foundations/Spinner';
import Icon from '../../foundations/Icons';

export type PromptProps = {
  onRequestClose?: () => void;
  onAccept?: (...args) => void;
  isOpen?: boolean;
  title: React.ReactNode;
  loading?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  cancelActionLabel?: string;
  hasFooter?: boolean;
  actionLabel?: string;
  actionType?: 'button' | 'submit';
  subtitle?: string;
  footer?: JSX.Element;
  displayCloseButton?: boolean;
};

export const Prompt = ({
  isOpen = false,
  displayCloseButton = true,
  hasFooter = true,
  title = '',
  subtitle = '',
  children,
  footer = undefined,
  cancelActionLabel = 'Cancel',
  loading = false,
  disabled = false,
  actionLabel = '',
  actionType = 'button',
  onAccept = undefined,
  onRequestClose = () => {},
}: PromptProps) => (
  <Base isOpen={isOpen} onRequestClose={onRequestClose}>
    <div className="px-s pb-s pt-m bg-card sm:p-s">
      <div className="flex justify-between">
        <div className="pb-m">
          {Boolean(title) && (
            <h3 className="font-heading text-h3 text-strong">{title}</h3>
          )}
          {subtitle && (
            <h4 className="font-heading text-h4 text-subtle">{subtitle}</h4>
          )}
        </div>

        {displayCloseButton && (
          <div className="hidden pt-xxxs sm:block">
            <div
              onClick={onRequestClose}
              onKeyPress={onRequestClose}
              role="button"
              tabIndex={0}
            >
              <Icon name="lClose" />
            </div>
          </div>
        )}
      </div>

      <div>{children}</div>
    </div>
    {hasFooter && (
      <>
        {footer || (
          <div className="px-s py-xs sm:flex sm:flex-row-reverse sm:px-l">
            <div>
              <Button
                type="button"
                variant="tertiary"
                disabled={loading}
                onClick={onRequestClose}
              >
                {cancelActionLabel}
              </Button>

              <Button
                type={actionType}
                variant="primary"
                onClick={() => {
                  if (onAccept && !loading) {
                    onAccept();
                  }
                }}
                disabled={(loading || disabled) ?? false}
              >
                {!loading ? (
                  actionLabel
                ) : (
                  <SpinnerCenterHelper>
                    <Spinner size="M" color="white" />
                  </SpinnerCenterHelper>
                )}
              </Button>
            </div>
          </div>
        )}
      </>
    )}
  </Base>
);

export default Prompt;
